export default __webpack_public_path__ + "static/media/county_fair.367897ec.png";